import { mainFetch } from "../mainFetch";

const SERVICE_URL = '/shipment/work'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class ShipmentWorkApi {

    static async pickerScan({ data = { postingNumbers: undefined }, ...params }) {
        return await fetchService({ url: '/printsticker', method: 'PATCH', data, options: { pdf: true }, ...params })
    }

    static async changePrint({ data = { postingNumbers: undefined, isPrint: undefined }, ...params }) {
        return await fetchService({ url: '/changeprintstatus', method: 'PATCH', data, ...params })
    }

    static async packerScan({ data = { postingBarcode: undefined, scanerId: undefined }, ...params }) {
        return await fetchService({ url: '/packerscan', method: 'PATCH', data, ...params })
    }

    static async packerScanFbo({ data = { postingBarcode: undefined, scanerId: undefined }, ...params }) {
        return await fetchService({ url: '/packerscanfbo', method: 'PATCH', data, ...params })
    }

    static async sortScan({ data = { postingBarcode: undefined, scanerId: undefined }, ...params }) {
        return await fetchService({ url: '/sortscan', method: 'PATCH', data, ...params })
    }

}